/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * App 内嵌终端：home_app（由同名 WAP 终端全量派生，B 位 *_wap 重写为 home_app，C/D 不变；404 个 D 位坑位，19 个 C 位模块）。
 * 数据源：home_wap（全量派生）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 * 首页楼层的分组键仅用于选择模板，C 段统一为 {component_id}_{id}；全局模块保留固定 C 段。
 * 楼层模板需绑定实际 component_id/id 后使用；运行时由 useHomeSpmModuleCode 生成实际模块码，不能直接上报占位符。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const HOME_APP_SPM_CODES = {
  best_sellers: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'product_{NNN}': `${sitePrefix}.home_app.{component_id}_{id}.product_{NNN}`,
    'tab_option_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.tab_option_{NN}`,
    view_more: `${sitePrefix}.home_app.{component_id}_{id}.view_more`,
  },
  eyewear_inspiration: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'open_eyewear_inspiration{N}': `${sitePrefix}.home_app.{component_id}_{id}.open_eyewear_inspiration{N}`,
  },
  footer_app: {
    code: `${sitePrefix}.home_app.footer_app`,
    download_android_app: `${sitePrefix}.home_app.footer_app.download_android_app`,
    open_download_on_the_app_store: `${sitePrefix}.home_app.footer_app.open_download_on_the_app_store`,
  },
  footer_help: {
    code: `${sitePrefix}.home_app.footer_help`,
    open_help_center: `${sitePrefix}.home_app.footer_help.open_help_center`,
    open_order_tracking: `${sitePrefix}.home_app.footer_help.open_order_tracking`,
  },
  footer_navigation: {
    code: `${sitePrefix}.home_app.footer_navigation`,
    'footer_group_toggle_{NN}': `${sitePrefix}.home_app.footer_navigation.footer_group_toggle_{NN}`,
    'footer_link_{NN}': `${sitePrefix}.home_app.footer_navigation.footer_link_{NN}`,
  },
  footer_social: {
    code: `${sitePrefix}.home_app.footer_social`,
    'social_entry_{NN}': `${sitePrefix}.home_app.footer_social.social_entry_{NN}`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.home_app.footer_subscribe`,
    email_input: `${sitePrefix}.home_app.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.home_app.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.home_app.header_tools`,
    cart_entry: `${sitePrefix}.home_app.header_tools.cart_entry`,
    logo_entry: `${sitePrefix}.home_app.header_tools.logo_entry`,
    open_account: `${sitePrefix}.home_app.header_tools.open_account`,
    open_search: `${sitePrefix}.home_app.header_tools.open_search`,
    toggle_navigation: `${sitePrefix}.home_app.header_tools.toggle_navigation`,
  },
  hero_banner: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'banner_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.banner_{NN}`,
    'slide_indicator_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.slide_indicator_{NN}`,
  },
  mobile_navigation: {
    code: `${sitePrefix}.home_app.mobile_navigation`,
    'nav_item_{NN}': `${sitePrefix}.home_app.mobile_navigation.nav_item_{NN}`,
    open_contact_us: `${sitePrefix}.home_app.mobile_navigation.open_contact_us`,
    open_help_center: `${sitePrefix}.home_app.mobile_navigation.open_help_center`,
    open_order_tracking: `${sitePrefix}.home_app.mobile_navigation.open_order_tracking`,
    site_settings_entry: `${sitePrefix}.home_app.mobile_navigation.site_settings_entry`,
    'social_entry_{NN}': `${sitePrefix}.home_app.mobile_navigation.social_entry_{NN}`,
    'submenu_item_{NN}_{NN}': `${sitePrefix}.home_app.mobile_navigation.submenu_item_{NN}_{NN}`,
  },
  new_customer_offer: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'banner_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.banner_{NN}`,
  },
  personalized_recommendations: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'action_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.action_{NN}`,
    'color_swatch_{NNN}_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.color_swatch_{NNN}_{NN}`,
    'favorite_{NNN}': `${sitePrefix}.home_app.{component_id}_{id}.favorite_{NNN}`,
    'product_{NNN}': `${sitePrefix}.home_app.{component_id}_{id}.product_{NNN}`,
    'recommendation_group_{NN}_product_{NNN}': `${sitePrefix}.home_app.{component_id}_{id}.recommendation_group_{NN}_product_{NNN}`,
    'tab_option_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.tab_option_{NN}`,
    toggle_product_layout: `${sitePrefix}.home_app.{component_id}_{id}.toggle_product_layout`,
  },
  product_floor_01: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'color_swatch_{NNN}_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.color_swatch_{NNN}_{NN}`,
    'favorite_{NNN}': `${sitePrefix}.home_app.{component_id}_{id}.favorite_{NNN}`,
    'product_{NNN}': `${sitePrefix}.home_app.{component_id}_{id}.product_{NNN}`,
    view_more: `${sitePrefix}.home_app.{component_id}_{id}.view_more`,
    view_more_tile: `${sitePrefix}.home_app.{component_id}_{id}.view_more_tile`,
  },
  quick_categories: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'category_entry_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.category_entry_{NN}`,
  },
  service_promises: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'service_entry_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.service_entry_{NN}`,
  },
  shop_by_lenses: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'lens_entry_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.lens_entry_{NN}`,
  },
  shop_by_shapes: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'shape_entry_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.shape_entry_{NN}`,
  },
  shop_by_vibes: {
    code: `${sitePrefix}.home_app.{component_id}_{id}`,
    'style_entry_{NN}': `${sitePrefix}.home_app.{component_id}_{id}.style_entry_{NN}`,
  },
  site_notice: {
    code: `${sitePrefix}.home_app.site_notice`,
    open_promotion: `${sitePrefix}.home_app.site_notice.open_promotion`,
  },
} as const satisfies SpmPageCodes;
